import { AxiosInstance } from 'axios';
import { ArrivalReportServiceType, initArrivalReportService } from '../pages/ArrivalReportPage/api';
import { DailyReportServiceType, initDailyReportService } from '../pages/DailyReportPage/api';
import {
  DepartureReportServiceType,
  initDepartureReportService,
} from '../pages/DepartureReportPage/api';
import { InHouseReportServiceType, initInHouseReportService } from '../pages/InHouseReportPage/api';
import {
  initRoomMoveReportService,
  RoomMoveReportServiceType,
} from '../pages/RoomMoveReportPage/api';
import {
  initRoomStateReportService,
  RoomStateReportServiceType,
} from '../pages/RoomStateReportPage/api';

export interface FrontdeskReportServiceType {
  arrivalReport: ArrivalReportServiceType;
  departureReport: DepartureReportServiceType;
  inHouseReport: InHouseReportServiceType;
  roomStateReport: RoomStateReportServiceType;
  dailyReport: DailyReportServiceType;
  roomMoveReport: RoomMoveReportServiceType;
}

export const initFrontdeskReportService = (axios: AxiosInstance): FrontdeskReportServiceType => ({
  arrivalReport: initArrivalReportService(axios),
  departureReport: initDepartureReportService(axios),
  inHouseReport: initInHouseReportService(axios),
  roomStateReport: initRoomStateReportService(axios),
  dailyReport: initDailyReportService(axios),
  roomMoveReport: initRoomMoveReportService(axios),
});
